
import {throwError as observableThrowError } from 'rxjs';
import * as moment from 'moment';
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/Rx';

import { LoginService } from '../../login/shared/login.service';
import { DataService } from '../../user-detail.service';
import { environment } from './../../../environments/environment';

@Injectable()
export class TimestampCebuService {
    redirectUrl: string;
    staffid;

    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
        private dataService: DataService
    ) { 
        this.staffid = this.dataService.getStaffInformation._id;
    }

    clockIn(id: number) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/timestamp/timein/'+ id, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    clockOut(id: string) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/timestamp/timeout?staff_id='+this.staffid+'&_id='+id, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    checkTimestamp() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/timestamp/today_timestamp?staff_id='+this.staffid+'&tz_offset='+new Date().getTimezoneOffset(), options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    logClock(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/timestamp/maketime', data, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    getBranch() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/individual_employment_setting/detail_by_date?staff_id='+ this.staffid + '&date=' + moment().format('YYYY-MM-DD'), options).pipe(
                    map(function(resp : any) {
                        let data = resp;
                        if (data.message) {
                            return null;
                        } else {
                            return data.data.branch_office;
                        }
                    }),
                    catchError(this.handleError),);
    }

    getVLandSL(id) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/vacation_management/detail/' + id, options).pipe(
                    map(this.extractData),
                    catchError(this.handleError),);
    }

    private extractData(res: any) {
        let body = res;
        return body.data || {};
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
        const body = error || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}